<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="800px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form
      ref="productForm"
      :model="formData"
      :rules="formRules"
      label-width="120px"
      :disabled="isView"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="产品名称" prop="product_name">
            <el-input v-model="formData.product_name" placeholder="请输入产品名称" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="产品类别" prop="frequency_type">
            <el-select v-model="formData.frequency_type" placeholder="请选择产品类别">
              <el-option label="单票" :value="1" />
              <el-option label="年保" :value="2" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="产品价格(元/起)" prop="min_premium">
            <el-input-number 
              v-model="formData.min_premium" 
              :min="0" 
              :precision="2"
              style="width: 100%"
              placeholder="请输入产品价格" 
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所属栏目" prop="biz_poster_category_id">
            <el-cascader
              v-model="formData.biz_poster_category_id"
              :options="categoryList"
              :props="{ value: 'id', label: 'text', children: 'children', expandTrigger: 'hover', emitPath: false }"
              placeholder="请选择所属栏目"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-form-item label="产品描述" prop="description">
        <el-input 
          v-model="formData.description" 
          type="textarea" 
          :rows="3"
          placeholder="请输入产品描述"
        />
      </el-form-item>
      
      <el-form-item label="产品链接" prop="jump_url">
        <el-input v-model="formData.jump_url" placeholder="请输入产品链接" />
      </el-form-item>
      
      <el-form-item label="状态" prop="disabled" v-if="!isView">
        <el-radio-group v-model="formData.disabled">
          <el-radio :label="false">启用</el-radio>
          <el-radio :label="true">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    
    <div slot="footer" class="dialog-footer" v-if="!isView">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="handleSubmit">
        确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveProduct, getProductInfo } from '@/api/custom-frontend'

export default {
  name: 'ProductListEditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    productData: {
      type: Object,
      default: null
    },
    appInfo: {
      type: Object,
      required: true
    },
    categoryList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      submitLoading: false,
      formData: {
        product_name: '',
        frequency_type: 1, // 默认单票
        min_premium: 0,
        biz_poster_category_id: null,
        description: '',
        jump_url: '',
        disabled: false
      },
      formRules: {
        product_name: [
          { required: true, message: '请输入产品名称', trigger: 'blur' }
        ],
        frequency_type: [
          { required: true, message: '请选择产品类别', trigger: 'change' }
        ],
        min_premium: [
          { required: true, message: '请输入产品价格', trigger: 'blur' }
        ],
        biz_poster_category_id: [
          { required: true, message: '请选择所属栏目', trigger: 'change' }
        ],
        jump_url: [
          { required: true, message: '请输入产品链接', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    
    dialogTitle() {
      if (this.isView) return '查看产品'
      return this.productData ? '编辑精研产品' : '添加精研产品'
    },
    
    isView() {
      return this.productData && this.productData.action === 'view'
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.initFormData()
      }
    }
  },
  methods: {
    async initFormData() {
      if (this.productData && this.productData.id) {
        // 编辑模式，获取详细信息
        try {
          const res = await getProductInfo({ id: this.productData.id })
          if (res && res.err_code === 0) {
            this.formData = {
              id: res.data.id,
              product_name: res.data.product_name,
              frequency_type: res.data.frequency_type,
              min_premium: res.data.min_premium,
              biz_poster_category_id: res.data.biz_poster_category_id,
              description: res.data.description,
              jump_url: res.data.jump_url,
              disabled: res.data.disabled
            }
          }
        } catch (error) {
          console.error('获取产品详情失败:', error)
        }
      } else {
        // 新增模式
        this.formData = {
          product_name: '',
          frequency_type: 1,
          min_premium: 0,
          biz_poster_category_id: null,
          description: '',
          jump_url: '',
          disabled: false
        }
      }
    },
    
    async handleSubmit() {
      if (this.isView) return
      
      try {
        await this.$refs.productForm.validate()
        
        this.submitLoading = true
        const submitData = {
          ...this.formData,
          app_id: this.appInfo.id,
          os_type: this.appInfo.os_type || 1
        }
        
        const res = await saveProduct(submitData)
        if (res && res.err_code === 0) {
          this.$message.success('保存成功')
          this.$emit('refresh')
          this.handleClose()
        } else {
          this.$message.error(res.err_msg || '保存失败')
        }
      } catch (error) {
        console.error('保存产品失败:', error)
        this.$message.error('保存失败')
      } finally {
        this.submitLoading = false
      }
    },
    
    handleClose() {
      this.dialogVisible = false
      this.$refs.productForm.resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
// 样式可以根据需要添加
</style>